/**
 * Homepage Video Testimonials carousel (Grüns-inspiriert).
 * - Klick auf den Play-Button einer Video-Karte fügt das echte <video>
 *   AN ORT UND STELLE ein (gleiche Kartengröße, kein Modal/Vergrößerung).
 *   Das Poster bleibt sichtbar (mit Lade-Spinner) bis das Video wirklich
 *   zu spielen beginnt.
 * - WICHTIG: Auf breiten Screens sind mehrere Karten gleichzeitig sichtbar,
 *   d.h. es gibt WENIGER erreichbare Scroll-Positionen als Karten (z.B. 6
 *   Karten aber nur 3 sinnvolle Stopps, wenn 4 gleichzeitig passen). Die
 *   Punkt-Navigation baut deshalb genau einen Punkt PRO ERREICHBARER
 *   POSITION (maxIndex+1), nicht einen Punkt pro Karte - vorher fuehrte
 *   das dazu, dass hintere Punkte nie erreichbar waren ("haengt" bei
 *   Punkt 3) und der Index an der Grenze zwischen zwei Punkten hin- und
 *   herspringen konnte (Safari). Wird bei Resize neu berechnet, da sich
 *   die Anzahl sichtbarer Karten je nach Breakpoint aendert.
 * - Der LETZTE Index scrollt immer exakt auf getMaxScroll() (nicht
 *   index*step), da index*step wegen der Rundung in getMaxIndex() leicht
 *   UNTER dem wahren Scroll-Maximum liegen kann - sonst bleibt die letzte
 *   Karte am rechten Rand minimal abgeschnitten.
 * - Pfeile werden nie per `disabled`-Attribut hart deaktiviert (nur
 *   optisch abgedunkelt).
 * - Die ERSTE Video-Karte (data-vtc-first) startet automatisch eine
 *   stumme, endlos loopende Vorschau, sobald die Section in den
 *   sichtbaren Bereich scrollt (IntersectionObserver -> erst dann wird
 *   ueberhaupt etwas geladen, kein Effekt auf die initiale Page-Speed).
 */
(function () {
  function initCarousel(root) {
    var row = root.querySelector('[data-vtc-row]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-vtc-card]'));
    var dotsHost = root.querySelector('[data-vtc-dots]');
    var prevBtn = root.querySelector('[data-vtc-prev]');
    var nextBtn = root.querySelector('[data-vtc-next]');
    if (!row || !cards.length) return;

    function getStep() {
      var styles = window.getComputedStyle(row);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }

    function getMaxScroll() {
      return Math.max(0, row.scrollWidth - row.clientWidth);
    }

    function getMaxIndex() {
      var step = getStep();
      if (!step) return 0;
      return Math.max(0, Math.round(getMaxScroll() / step));
    }

    var dots = [];
    var lastMaxIndex = -1;

    function buildDots() {
      var maxIndex = getMaxIndex();
      if (maxIndex === lastMaxIndex) return;
      lastMaxIndex = maxIndex;
      dotsHost.innerHTML = '';
      dots = [];
      for (var i = 0; i <= maxIndex; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'vtc__dot';
          dot.setAttribute('aria-label', 'Zu Position ' + (index + 1) + ' springen');
          dot.addEventListener('click', function () { goToIndex(index); });
          dotsHost.appendChild(dot);
          dots.push(dot);
        })(i);
      }
    }

    function currentIndex() {
      var step = getStep();
      if (!step) return 0;
      var index = Math.round(row.scrollLeft / step);
      return Math.max(0, Math.min(index, getMaxIndex()));
    }

    var trackedIndex = 0;

    function renderState(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      var maxIndex = getMaxIndex();
      if (prevBtn) prevBtn.classList.toggle('is-disabled', index <= 0);
      if (nextBtn) nextBtn.classList.toggle('is-disabled', maxIndex <= 0 || index >= maxIndex);
    }

    function syncFromScroll() {
      buildDots();
      trackedIndex = currentIndex();
      renderState(trackedIndex);
    }

    var correctionTimer = null;
    function goToIndex(index) {
      var maxIndex = getMaxIndex();
      index = Math.max(0, Math.min(index, maxIndex));
      trackedIndex = index;
      renderState(index);

      // Letzter Index: immer exakt bis zum wahren Scroll-Ende fahren, sonst
      // kann index*step (Rundungsfehler von getMaxIndex) knapp darunter liegen
      // und die letzte Karte bleibt am rechten Rand leicht sichtbar/abgeschnitten.
      var target = index >= maxIndex ? getMaxScroll() : index * getStep();

      clearTimeout(correctionTimer);
      row.scrollTo({ left: target, behavior: 'smooth' });

      correctionTimer = setTimeout(function () {
        if (Math.abs(row.scrollLeft - target) > 4) {
          row.scrollLeft = target;
        }
        trackedIndex = currentIndex();
        renderState(trackedIndex);
      }, 420);
    }

    var scrollTimer;
    row.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        trackedIndex = currentIndex();
        renderState(trackedIndex);
      }, 150);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goToIndex(trackedIndex - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goToIndex(trackedIndex + 1); });
    }

    buildDots();
    syncFromScroll();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncFromScroll, 150);
    });

    function stopAmbient(card) {
      var ambient = card.querySelector('.vtc__video--ambient');
      if (ambient) ambient.remove();
      var poster = card.querySelector('.vtc__poster');
      if (poster) poster.classList.remove('vtc__poster--faded');
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-vtc-play]');
      if (!trigger || trigger.classList.contains('is-loading')) return;
      var card = trigger.closest('[data-vtc-card]');
      var templateEl = card ? card.querySelector('template[data-vtc-source]') : null;
      if (!card || !templateEl) return;

      stopAmbient(card);
      trigger.classList.add('is-loading');

      var fragment = templateEl.content.cloneNode(true);
      card.insertBefore(fragment, trigger);
      var video = card.querySelector('video:not(.vtc__video--ambient)');
      if (!video) {
        trigger.remove();
        return;
      }

      var revealed = false;
      function reveal() {
        if (revealed) return;
        revealed = true;
        trigger.remove();
      }

      video.addEventListener('playing', reveal, { once: true });
      setTimeout(reveal, 4000);

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () { reveal(); });
      }
    });

    // Stumme Vorschau nur fuer die erste Video-Karte, nur wenn sichtbar.
    var firstCard = root.querySelector('[data-vtc-first]');
    if (firstCard && 'IntersectionObserver' in window) {
      var started = false;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || started) return;
          started = true;
          observer.disconnect();

          var templateEl = firstCard.querySelector('template[data-vtc-source]');
          var poster = firstCard.querySelector('.vtc__poster');
          if (!templateEl) return;

          var fragment = templateEl.content.cloneNode(true);
          var ambientVideo = fragment.querySelector('video');
          if (!ambientVideo) return;
          ambientVideo.classList.add('vtc__video--ambient');
          ambientVideo.muted = true;
          ambientVideo.loop = true;
          ambientVideo.controls = false;
          ambientVideo.setAttribute('preload', 'metadata');
          ambientVideo.removeAttribute('controls');

          firstCard.insertBefore(fragment, firstCard.firstChild);

          ambientVideo.addEventListener('playing', function () {
            if (poster) poster.classList.add('vtc__poster--faded');
          }, { once: true });

          var playPromise = ambientVideo.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {
              ambientVideo.remove();
            });
          }
        });
      }, { threshold: 0.4 });
      observer.observe(root);
    }
  }

  document.querySelectorAll('[data-vtc]').forEach(initCarousel);
})();
